module.exports = {
  standardMonthlyPricePerMonth: '$8.99',
  standardMonthlyPricePerYear: '$107.88',
  standardYearlyPricePerMonth: '$5.99',
  standardYearlyPricePerYear: '$71.88',
  standardMonthlyPricePerMonthInCents: 899,
  standardYearlyPricePerYearInCents: 7188,
  percentageSavingStandardYearly: '33%',
}
